import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import './Menu.scss';

const SensorsMenu = (props, context) => {

  const projectsState = useSelector((state) => state.leaksList.projectsList);
  const selectedProjectId = useSelector((state) => state.leaksList.selectedProject);
  const selectedProjectIndex = projectsState.projectIndexMap[selectedProjectId];
  const projectItem = projectsState.items[selectedProjectIndex];

  if (! projectItem?.is_pressure_new) {
    return null;
  }

  const { onChange } = props;
  return (
    <div className="manage-menu">
      <button
        className="btn-menu Sensors"
        title={context.t('sensors')}
        onClick={() => onChange('Sensors')}
      />

      <button
        className="btn-menu PrsSensors"
        title={context.t('pressure_sensors')}
        onClick={() => onChange('PressureSensors')}
      />
    </div>
  );
}

SensorsMenu.contextTypes = {
  t: PropTypes.func.isRequired
}

export default SensorsMenu;
